module.exports = __webpack_public_path__ + "assets/mollie-secured.e3f5a1ad.svg";